import React from 'react';
import Image from './Image';

const ROOT_URL = process.env.PUBLIC_URL || '';

export default () => (
  <Image
    id="enview-logo"
    className="enview-logo"
    fileName='plural_sai360_logo.png'
    alt="Logo for Plural"
  />
);
